<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { textAboveBackground } = $AppState.theme.colors;

  export let color = textAboveBackground;
</script>

<svg
  class="twism-collapsed-svg-coupon"
  width="45"
  height="38"
  viewBox="0 0 48 41"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M38.0063 7.55986L7.96239 17.7175C7.17767 17.9828 6.7566 18.834 7.02191 19.6187L13.0616 37.4827C13.3269 38.2675 14.1781 38.6885 14.9628 38.4232L45.0067 28.2656C45.7914 28.0003 46.2125 27.1491 45.9472 26.3644L39.9075 8.50035C39.6422 7.71562 38.791 7.29455 38.0063 7.55986ZM7.3447 15.8905C5.55097 16.4969 4.58848 18.4427 5.19493 20.2364L11.2346 38.1004C11.8411 39.8942 13.7868 40.8566 15.5805 40.2502L45.6244 30.0926C47.4181 29.4861 48.3806 27.5404 47.7742 25.7467L41.7345 7.88266C41.128 6.08892 39.1823 5.12644 37.3886 5.73288L7.3447 15.8905Z"
    fill={color}
  />
  <path
    d="M23.047 20.6763C22.7588 19.8239 22.783 19.0721 23.1194 18.421C23.4672 17.766 24.0385 17.3042 24.8331 17.0355C25.6278 16.7669 26.3564 16.7892 27.0189 17.1026C27.6928 17.4122 28.1739 17.9931 28.4621 18.8455C28.754 19.7091 28.7261 20.4683 28.3783 21.1233C28.0419 21.7744 27.4763 22.2343 26.6816 22.503C25.887 22.7717 25.1527 22.7513 24.4788 22.4417C23.8162 22.1283 23.339 21.5398 23.047 20.6763ZM33.1261 14.4567L30.4153 28.4954L28.0995 29.2784L30.7932 15.2454L33.1261 14.4567ZM25.2939 18.4544C24.6695 18.6655 24.5052 19.2085 24.8009 20.0833C25.1005 20.9693 25.5625 21.3067 26.1868 21.0956C26.4933 20.992 26.6957 20.8049 26.794 20.5342C26.8884 20.2523 26.8598 19.8871 26.7081 19.4385C26.4124 18.5637 25.9409 18.2357 25.2939 18.4544ZM32.7919 24.8612C32.4999 23.9977 32.5241 23.2459 32.8643 22.606C33.2121 21.951 33.7834 21.4892 34.578 21.2205C35.3727 20.9518 36.0956 20.9761 36.7468 21.2933C37.4056 21.5955 37.8809 22.1784 38.1729 23.042C38.4649 23.9055 38.4426 24.6629 38.1062 25.314C37.7811 25.9613 37.2212 26.4193 36.4265 26.688C35.6205 26.9605 34.8862 26.9401 34.2237 26.6267C33.5611 26.3133 33.0839 25.7248 32.7919 24.8612ZM35.0388 22.6394C34.3917 22.8582 34.216 23.405 34.5118 24.2798C34.8113 25.1658 35.2847 25.4994 35.9317 25.2806C36.5675 25.0657 36.7356 24.5152 36.436 23.6292C36.1402 22.7544 35.6745 22.4245 35.0388 22.6394Z"
    fill={color}
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.9485 16.8472L13.3926 15.203L15.2195 14.5853L15.7755 16.2296L13.9485 16.8472ZM15.8015 22.3282L14.6897 19.0396L16.5167 18.4219L17.6285 21.7105L15.8015 22.3282ZM17.6546 27.8091L16.5428 24.5205L18.3698 23.9029L19.4816 27.1914L17.6546 27.8091ZM19.5077 33.29L18.3958 30.0015L20.2228 29.3838L21.3347 32.6724L19.5077 33.29ZM20.8048 37.1267L20.2489 35.4824L22.0759 34.8647L22.6318 36.509L20.8048 37.1267Z"
    fill={color}
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.1735 14.2578L30.2495 2.87409C30.9504 2.43266 31.8765 2.64303 32.3179 3.34397L34.4484 6.72687L36.3274 6.09158L33.9498 2.31623C32.9408 0.714012 30.8239 0.233137 29.2217 1.24217L2.38557 18.1428C0.783347 19.1519 0.302474 21.2687 1.31151 22.8709L11.3606 38.8276C12.0267 39.8853 13.1755 40.4543 14.3403 40.4287C12.9647 40.3713 11.702 39.4828 11.2346 38.1004L8.9777 31.4249L2.94342 21.8432C2.50199 21.1423 2.71236 20.2162 3.4133 19.7748L5.03519 18.7533C5.18058 17.4739 6.04414 16.3302 7.3447 15.8905L12.1735 14.2578Z"
    fill={color}
  />
</svg>

<style lang="scss">
  .twism-collapsed-svg-coupon {
    @media screen and (max-width: 468px) {
      width: 36px !important;
      height: 30px !important;
    }
  }
</style>
